import Components from './../Component';

export default class Flipbook extends Components {

  constructor($) {
    super($);
  }

  init(index, element) {
    if (document.referrer){
      this.$(element).find('a.btn-back').attr('href', document.referrer);
    }else{
      this.$(element).find('a.btn-back').remove();
    }

  }
}
